const SLIDE_DELIMITER = "--slide--"

/**
 * @param block is a string that should have an example content
  `
 --slide--
original: ![Ingredients image](https://res.cloudinary.com/theoomoregbee/image/upload/v1595386599/Ingredients_image_8a2b286ae0.png)
thumbnail: ![Ingredients image](https://res.cloudinary.com/theoomoregbee/image/upload/v1595386599/Ingredients_image_8a2b286ae0.png)
--slide--
original: ![Ingredients image](https://res.cloudinary.com/theoomoregbee/image/upload/v1595386599/Ingredients_image_8a2b286ae0.png)
thumbnail: ![Ingredients image](https://res.cloudinary.com/theoomoregbee/image/upload/v1595386599/Ingredients_image_8a2b286ae0.png)
  `
  @returns Array<{original: {title: string, src: string}, thumbnail: {title: string, src: string}}>
 */
export default (block = "") => {
  const getImageInfo = (imageMarkdownStr = "") => {
    const match = imageMarkdownStr.match(/!\[(.*?)\]\((.*?)\)/)
    if (match) {
      return { title: match[1], src: match[2] }
    }
  }

  const findAttribute = (lines, attribute = "original") => {
    for (const line of lines) {
      if (!line.includes(`${attribute}:`)) {
        continue
      }
      const found = line.split(`${attribute}:`)
      const value = found[found.length - 1]
      if (value) {
        return getImageInfo(value)
      }
    }
    return
  }

  const getSlideAttributes = (str = "") => {
    const lines = str.split("\n")
    const original = findAttribute(lines)
    const thumbnail = findAttribute(lines, "thumbnail")
    return { original, thumbnail }
  }

  return block
    .split(SLIDE_DELIMITER)
    .map(getSlideAttributes)
    .filter(item => item && item.original)
}
